// Modules
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { ReviewAprvApi, ReviewAprvUpApi } from '_Route/Api';


const AdReviewAprvList = () => {

  const [guideStatus, setGuideStatus] = useState(true);
  const [aprvData, setAprvData] = useState({
    bfData: [],
    afData: [],
  })
  const { bfData, afData } = aprvData;

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  // const userRoles = useSelector(state => state.authorityAcc.roles);

  const [curType, setCurType] = useState({ name: '검토자', key: 'specifier'})
  const btnList = [
    {name: '검토자', key: 'specifier'},
    {name: '승인자', key: 'approver'},
  ]

  const onJSON = (data) => {
    try {
      const parseData = JSON.parse(data)
      let resData = '';
      parseData?.map((r, i) => {
        resData += (parseData.length === i + 1) ? r : r + ', '
      })
      return resData;
    }
    catch (err) {
      return data
    }
  }


  /* ========================================================================
  * Axios Reviewer / Applover
  ========================================================================*/
  // 검토/승인자 목록 조회
  const getReviewAprvList = () => {
    axios({
      url: ReviewAprvApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        type: curType.key,
      }
    })
    .then(res => {
      //console.log(res, 'Reviewer / Applover List GET Success!')
      const r = res.data.result;
      setAprvData({...aprvData, bfData: r.is_r2, afData: r.is_r1})
    })
    .catch(err => {
      console.error(err, "Reviewer / Applover List GET Error...");
    })
  }

  // 검토/승인자 목록 추가/삭제
  const addReviewAprvList = (targetUid, targetName, type, as = 0) => {
    axios({
      url: ReviewAprvUpApi,
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        uid: targetUid,
        type: curType.key,
      },
    })
    .then(res => {
      console.log(res, 'Reviewer / Applover List PUT Success!')
      if (as === 0) {
        alert(`${targetName} 님을 ${curType.name} 지정 목록에${type === 'bf' ? " 추가" : "서 삭제"}하였습니다.`)
      }
    })
    .catch(err => {
      console.error(err, "Reviewer / Applover List PUT Error...");
      if(err.response.data.message) {
        alert(err.response.data.message)
      }
    })
    .finally(() => {
      getReviewAprvList()
    })
  }

  // 검토/승인자 일괄 추가/삭제
  const allHandler = (type) => {
    const curData = type === 'bf' ? bfData : afData

    if (curData.length > 0) {
      curData.map(data => {
        addReviewAprvList(data.acc_uuid, data.acc_name, type, 1)
      })
      alert(`모든 회원을 ${curType.name} 지정 가능 목록에${type === 'bf' ? ' 추가' : '서 삭제'} 하였습니다.`)
    } else {
      alert(`${type === 'bf' ? '추가' : '삭제'} 가능한 회원이 존재하지 않습니다.`)
    }
  }

  useEffect(() => {
    getReviewAprvList()
  }, [curType])


  return (
    <>
      <div className="adContTitGroup">
        <h2>검토/승인자 목록 관리</h2>
        <p>Home / 검토/승인 / 검토/승인자 목록 관리 <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 검토자 및 승인자를 지정 가능 목록에 <span className="blueTxt">등록/삭제</span>할 수 있습니다.</li>
        </ul>
      </div>

      <div className="adContArea">
        <h3>
          {curType.name} 등록
          <span className="textTab">
            {btnList.map((list, i) => 
              <button key={i} type="button" className={`btn xs ${curType.key === list.key ? 'sfrtBlue' : 'blue_edge'} round_10`} onClick={() => setCurType(list)}>{list.name}</button>
            )}
          </span>
        </h3>

        <fieldset>
          <legend>검토/승인자 등록</legend>

          <div className="fieldGroup">
            <label>{curType.name} 지정 목록 추가 가능 회원<span className="redTxt">*</span></label>

            <div className="divItemBox">
              <ul>
                {bfData.length > 0 ?
                  bfData?.map((data, i) =>
                    <li key={i}>
                      <i className="icofont-plus" style={{fontSize: '14px'}} />
                      <button type="button" onClick={() => addReviewAprvList(data.acc_uuid, data.acc_name, 'bf')}>{data.acc_name} - {data.acc_email} - {onJSON(data.acc_roles)}</button>
                    </li>
                  )
                  :
                  <li className="noData">
                    <i className="icofont-warning-alt"></i>
                    <p>{curType.name} 목록에 추가 가능한 회원이 존재하지 않습니다.</p>
                  </li>
                }
              </ul>
            </div>
          </div>
          <div className="fieldGroup">
            <label>{curType.name} 지정 가능 회원<span className="redTxt">*</span></label>

            <div className="divItemBox">
              <ul>
                {afData.length > 0 ?
                  afData?.map((data, i) => 
                    <li key={i}>
                      <i className="icofont-close" />
                      <button type="button" onClick={() => addReviewAprvList(data.acc_uuid, data.acc_name, 'af')}>{data.acc_name} - {data.acc_email} - {onJSON(data.acc_roles)}</button>
                    </li>
                  )
                  :
                  <li className="noData">
                    <i className="icofont-warning-alt"></i>
                    <p>{curType.name}로 지정 가능한 회원이 존재하지 않습니다.</p>
                  </li>
                }
              </ul>
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          <button type="button" className="btn sm sfrtBlue round_10" onClick={() => allHandler('bf')}>{curType.name} 목록 전체 추가</button>
          <button type="button" className="btn sm red round_10" onClick={() => allHandler('af')}>{curType.name} 목록 전체 삭제</button>
        </div>
      </div>
    </>
  )
}

export default AdReviewAprvList